import Grid from "@mui/material/Unstable_Grid2";
import { DialogContent, TextField } from "@mui/material";
import React from "react";
import useContactsStore from "../../../../stores/useContactsStore";

const EditContactDialogContent = () => {
  const { currentContact, updateCurrentContactField } = useContactsStore();

  return (
    <DialogContent
      sx={{
        padding: "30px 24px",
        "& .MuiDialogContent-root": {
          paddingTop: "20px",
        },
      }}
    >
      <Grid container spacing={1}>
        <Grid xs={6}>
          <TextField
            fullWidth
            label="Titel"
            variant="outlined"
            onChange={(e) => updateCurrentContactField("titel", e.target.value)}
            defaultValue={currentContact.titel}
          />
        </Grid>
        <Grid xs={6}>
          <TextField
            fullWidth
            title=""
            label="Funktion"
            variant="outlined"
            onChange={(e) =>
              updateCurrentContactField("funktion", e.target.value)
            }
            defaultValue={currentContact.funktion}
          />
        </Grid>
        <Grid xs={6}>
          <TextField
            fullWidth
            required
            title=""
            label="Vorname"
            variant="outlined"
            onChange={(e) =>
              updateCurrentContactField("vorname", e.target.value)
            }
            defaultValue={currentContact.vorname}
            helperText={"Dieses Feld ist erforderlich"}
          />
        </Grid>
        <Grid xs={6}>
          <TextField
            fullWidth
            required
            title=""
            label="E-Mail"
            variant="outlined"
            onChange={(e) => updateCurrentContactField("email", e.target.value)}
            defaultValue={currentContact.email}
            helperText={"Dieses Feld ist erforderlich"}
          />
        </Grid>
        <Grid xs={6}>
          <TextField
            fullWidth
            required
            title=""
            label="Nachname"
            variant="outlined"
            onChange={(e) =>
              updateCurrentContactField("nachname", e.target.value)
            }
            defaultValue={currentContact.nachname}
            helperText={"Dieses Feld ist erforderlich"}
          />
        </Grid>
        <Grid xs={6}>
          <TextField
            fullWidth
            label="Telefon"
            title=""
            variant="outlined"
            onChange={(e) =>
              updateCurrentContactField("telbuero", e.target.value)
            }
            defaultValue={currentContact.telbuero}
          />
        </Grid>
        <Grid xs={6}>
          <TextField
            fullWidth
            label="Namenszusatz"
            variant="outlined"
            onChange={(e) =>
              updateCurrentContactField("namensZusatz", e.target.value)
            }
            defaultValue={currentContact.namensZusatz}
          />
        </Grid>
        <Grid xs={6}>
          <TextField
            fullWidth
            label="Mobiltelefon"
            title=""
            variant="outlined"
            onChange={(e) =>
              updateCurrentContactField("telmobil", e.target.value)
            }
            defaultValue={currentContact.telmobil}
          />
        </Grid>
        <Grid xs={6}>
          <TextField
            fullWidth
            label="Nachgestellter Titel"
            variant="outlined"
            onChange={(e) =>
              updateCurrentContactField("nachgestellterTitel", e.target.value)
            }
            defaultValue={currentContact.nachgestellterTitel}
          />
        </Grid>
      </Grid>
    </DialogContent>
  );
};

export default EditContactDialogContent;
